import React from 'react';

const BookingIcon = ({ colorFill = '#3D3D3D' }: { colorFill?: string }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 5.25V6H18V5.25C18 3.18225 16.3178 1.5 14.25 1.5H13.5V0.75C13.5 0.336 13.1648 0 12.75 0C12.3353 0 12 0.336 12 0.75V1.5H6V0.75C6 0.336 5.66475 0 5.25 0C4.83525 0 4.5 0.336 4.5 0.75V1.5H3.75C1.68225 1.5 0 3.18225 0 5.25ZM18 14.25V7.5H0V14.25C0 16.3178 1.68225 18 3.75 18H14.25C16.3178 18 18 16.3178 18 14.25ZM8.08787 15.4914L13.473 10.2075L12.709 9.4288L8.08787 13.9631L5.83666 11.7542L5.07262 12.5328L8.08787 15.4914Z" fill={colorFill}/>
        </svg>
    )
};

export default BookingIcon;
